/**
 * CrowdTalkie Internationalization (i18n) Setup
 * Supports English and Spanish with browser language detection
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'

// Detect browser language
const browserLang = navigator.language.split('-')[0] || 'en'
const supportedLangs = ['en', 'es']
const defaultLang = supportedLangs.includes(browserLang) ? browserLang : 'en'

// Check for stored preference
const storedLang = localStorage.getItem('crowdtalkie-lang')

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: storedLang ?? defaultLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false, // Avoid suspense for SSR compatibility
    },
  })

// Persist language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('crowdtalkie-lang', lng)
  document.documentElement.lang = lng
})

// Set initial document language
document.documentElement.lang = i18n.language

export default i18n

// Helper to change language
export function setLanguage(lang: 'en' | 'es'): void {
  i18n.changeLanguage(lang)
}

// Get current language
export function getLanguage(): string {
  return i18n.language
}

// Supported languages for UI
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
] as const
